import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';
import { Compromiso } from 'src/app/shared/models/compromiso.model';
import { CompromisoService } from 'src/app/shared/services/compromiso.service';
import { Comunidad } from '../../communities/types';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-communities-commitments',
  templateUrl: './communities.component.html',
  styleUrls: ['./communities.component.scss'],
})
export class CommunitiesCommitmentsComponent implements OnInit {
  compromisosList: Compromiso[] = [];

  currentFilter: string = 'Fibras';
  communities!: Comunidad[];
  img_base = environment.img_base;

  constructor(
    private compromisoService: CompromisoService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.loadCompromisos();
    });
    this.communities = this.route.snapshot.data['communities'] as Comunidad[];
    this.communities.sort((a, b) => {
      if (
        a.nombre.toLowerCase().normalize('NFD') <
        b.nombre.toLowerCase().normalize('NFD')
      )
        return -1;
      if (
        a.nombre.toLowerCase().normalize('NFD') >
        b.nombre.toLowerCase().normalize('NFD')
      )
        return 1;
      return 0;
    });
  }

  loadCompromisos(): void {
    this.compromisoService.getCompromisos(null).subscribe((data: any) => {
      this.compromisosList = data.commitments;
    });
  }

  setFilter(community: string) {
    this.currentFilter = community;
  }
}
